import { Controller } from 'stimulus'

export default class extends Controller {
    connect() {
        this.productId = this.element.dataset.productId;
        this.productName = this.element.dataset.productName;
        this.productPrice = this.element.dataset.productPrice;
        this.categoryNamesGTM = JSON.parse(this.element.dataset.productCategoryNamesGtm);
        this.productVariant = this.element.dataset.productVariant;
        this.productManufacturer = this.element.dataset.productBrand;
        this.position = this.element.dataset.position;
        this.list = this.element.dataset.list ? this.element.dataset.list.toLocaleLowerCase() : null;

    }

    manageClickImpression(event) {
        let data = {
            list: this.list,
            product: {
                id: this.productId,
                name: this.productName,
                categoryNamesGTM: this.categoryNamesGTM,
                variant: this.productVariant,
                price: this.productPrice,
                brand: this.productManufacturer,
                position: this.position,
                list: this.list,
            }
        }

        EventManager.fire('gtm-event', {
            event: 'select_item',
            eventData: data
        });
    }
}